// Annual Planner discovery promo — shown when no periodization is set.
// Presentation-only: sits between the Hero chart and the Bodyweight goal section.

import React, { memo } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import SvgIcon from "../../../../../parts/SvgIcon";

const CALENDAR_ICON = "/img/new-icons/calendar-ico-white.svg";
const CHECK_ICON = "/img/new-icons/check-bold.svg";
const EXTERNAL_LINK_ICON = "/img/new-icons/export.svg";

const BENEFIT_KEYS = ["benefitSeePhases", "benefitCatchMismatches", "benefitPlanAhead"];

const p = (t, key, opts) => t(`nutritionPage.progress.plannerPromo.${key}`, opts);

export const PlannerPromo = memo(({ athlete }) => {
  const { t } = useTranslation("athlete-portal");
  const plannerHref = `/athlete-portal/profile?section=periodization&athlete=${athlete._id}`;

  return (
    <div className="np-planner-promo">
      <div className="np-planner-promo__body">
        <div className="np-planner-promo__header">
          <SvgIcon src={CALENDAR_ICON} useCurrentColor classNames="np-planner-promo__icon" />
          <span className="np-planner-promo__title">{p(t, "title")}</span>
        </div>
        <p className="np-planner-promo__desc">{p(t, "description")}</p>
        <ul className="np-planner-promo__list">
          {BENEFIT_KEYS.map((key) => (
            <li key={key} className="np-planner-promo__list-item">
              <SvgIcon src={CHECK_ICON} useCurrentColor classNames="np-planner-promo__check" />
              {p(t, key)}
            </li>
          ))}
        </ul>
      </div>
      <a // NOSONAR
        role="button" 
        data-button-type="primary"
        className="np-planner-promo__cta"
        href={plannerHref}
      >
        {p(t, "cta")}
        <SvgIcon src={EXTERNAL_LINK_ICON} useCurrentColor classNames="np-planner-promo__cta-icon" />
      </a>
    </div>
  );
});

PlannerPromo.propTypes = {
  athlete: PropTypes.shape({ _id: PropTypes.string }).isRequired,
};
